export default "/images/88ebd6f2c84e6b4896cc3dffc9c859c7.avif";